"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/function-component-definition */
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("~/components/UI/Button"));
const react_i18next_1 = require("react-i18next");
const events_1 = require("~/utils/events");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const UI_1 = require("~/components/UI");
const actions_1 = require("~/store/actions");
const routes_1 = require("~/consts/routes");
const react_router_dom_1 = require("react-router-dom");
const DeletionConfirmationModal_scss_1 = __importDefault(require("./DeletionConfirmationModal.scss"));
const DeletionConfirmationModal = ({ genericMode = false, startOfTitle, middleOfTitle, endOfTitle, onSubmit, }) => {
    const { t } = (0, react_i18next_1.useTranslation)('widgets');
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [password, setPassword] = (0, react_1.useState)('');
    const [error, setError] = (0, react_1.useState)(false);
    const { dispatchValidateTokenAction } = (0, redux_1.bindActionCreators)({
        dispatchValidateTokenAction: actions_1.validateTokenAction,
    }, (0, react_redux_1.useDispatch)());
    const cancelHandler = () => {
        (0, events_1.hideModal)();
    };
    const submitHandler = () => {
        dispatchValidateTokenAction(() => {
            (0, events_1.hideModal)();
            return navigate(routes_1.ROUTE_LOGIN);
        });
        onSubmit();
        (0, events_1.hideModal)();
    };
    (0, react_1.useEffect)(() => setError(false), [password]);
    return (react_1.default.createElement("div", { className: DeletionConfirmationModal_scss_1.default.content, "data-testid": "deletion-modal" },
        react_1.default.createElement("div", { className: DeletionConfirmationModal_scss_1.default.header },
            !genericMode ? t('deletion-confirmation-modal.start-of-title') : startOfTitle,
            react_1.default.createElement("b", null,
                " ",
                middleOfTitle),
            endOfTitle,
            "?",
            genericMode && error && react_1.default.createElement("div", { className: DeletionConfirmationModal_scss_1.default.error }, "Password is incorrect.")),
        genericMode && (react_1.default.createElement("div", { className: DeletionConfirmationModal_scss_1.default.password },
            react_1.default.createElement("span", null, "Confirm password"),
            react_1.default.createElement(UI_1.Input, { type: "password", placeholder: "********", value: password, onInput: (value, er) => setPassword(value) }))),
        react_1.default.createElement("div", { className: DeletionConfirmationModal_scss_1.default.footer },
            react_1.default.createElement(Button_1.default, { onClick: cancelHandler }, t('deletion-confirmation-modal.cancel')),
            react_1.default.createElement(Button_1.default, { onClick: submitHandler, variant: "primary", "data-testid": "deletion-modal-confirm", disabled: genericMode ? !(!!password && (password === null || password === void 0 ? void 0 : password.trim().length) >= 8) : false }, t(`deletion-confirmation-modal.${genericMode ? 'save' : 'delete'}`)))));
};
DeletionConfirmationModal.defaultProps = {
    startOfTitle: undefined,
    genericMode: undefined,
};
exports.default = DeletionConfirmationModal;
